import { FileDocIcon, FileIcon, FilePdfIcon } from '@phosphor-icons/react';
import type { DocumentFileKind } from '../../../types';

export const FILE_ICONS: Record<DocumentFileKind, typeof FileIcon> = {
    pdf: FilePdfIcon,
    word: FileDocIcon,
    other: FileIcon,
};
